import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";
import { AuthService } from "../../../services/authservice";
import { ServiceIcon } from "../../subscription-detail/service-icon/service-icon";

interface SubscriptionWithProduct {
  product: {
    tag: string;
  };
  subscriptionId: string;
}

@Component({
  selector: "dialog-ip-prefixes",
  templateUrl: "dialog-ip-prefixes.html",
  styleUrls: ["../../malfunction/malfunction-card/components/affected-subscription/affected-subscription.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, GuidPipe, ServiceIcon, TranslatePipe],
})
export class DialogIPPrefixesComponent {
  data = inject<{
    editModus: boolean;
    subscriptions;
    linkedSubscriptions;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<DialogIPPrefixesComponent>>(MatDialogRef);
  router = inject(Router);
  auth = inject(AuthService);

  protected editModus = false;
  private customerId = "";

  constructor() {
    const data = this.data;

    this.customerId = this.auth.viewingCustomer().customerId;
    if (data.editModus) {
      this.editModus = true;
    }
  }

  isAvailable(subscription: { customerId: string }) {
    return this.auth.viewingCustomer().customerId === subscription.customerId;
  }

  closeDialog(): void {
    this.dialogRef.close({ forceScrollTop: false });
  }

  segueToService(subscription: SubscriptionWithProduct) {
    if (this.editModus) {
      this.router.navigate([`/diensten/IP/${subscription.product.tag}/${subscription.subscriptionId}`], {
        state: { action: "addPrefix", selectedPrefix: this.data.subscriptions },
      });
    } else {
      this.router.navigate([`/subscription/${subscription.subscriptionId}`]);
    }

    this.dialogRef.close({ forceScrollTop: true });
  }
}
